import { Outlet, useLocation } from 'react-router-dom'
import GenerateApiKey from './GenerateApiKey'
import VerifyEmailAlert from './VerifyEmailAlert'
import AccountDeletionAlert from './AccountDeletionAlert'
import { getPageTitle } from '@/lib/pageTitle'

const SUBTITLES: [string, string][] = [
  ['/dashboard/messages', 'Send a message, send to a list, or review what went out.'],
  ['/dashboard/devices', 'The phones and WhatsApp numbers you send from.'],
  ['/dashboard/api', 'Keys that let your own software send through redgeGate.'],
  ['/dashboard/webhooks', 'Notify your server when messages are delivered or received.'],
  ['/dashboard/settings', 'Your account, plan and notifications.'],
]

export default function DashboardLayout() {
  const { pathname } = useLocation()
  const isOverview = pathname === '/dashboard' || pathname === '/dashboard/'
  // Overview has no static subtitle: it opens with a live summary sentence.
  const subtitle = SUBTITLES.find(([prefix]) => pathname.startsWith(prefix))?.[1]

  return (
    <div className="space-y-8">
      {/* Global alerts */}
      <div className="space-y-4">
        <AccountDeletionAlert />
        <VerifyEmailAlert />
      </div>

      {/* Page Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold text-ink">{getPageTitle(pathname)}</h1>
          {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
        </div>

        <div className="flex items-center space-x-3">
          {isOverview && <GenerateApiKey />}
        </div>
      </div>

      {/* Page Content */}
      <div className="min-h-[calc(100vh-200px)]">
        <Outlet />
      </div>
    </div>
  )
}
